import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import Flag from "react-world-flags";
import "./countryCodeSelect.css";
import countryOptions from "./countyOption";
import arrowDown from "../../Assets/PatientStatusSymbol/arrow-down.svg"

const CountryCodeSelect = ({ selectedValue, onChange, placeholder }) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(countryOptions);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const modalRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setMenuIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  useEffect(() => {
    if (searchTerm) {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      const newFilteredOptions = countryOptions.filter(
        (option) =>
          option.label.toLowerCase().includes(lowercasedSearchTerm) ||
          option.value.includes(lowercasedSearchTerm)
      );
      setFilteredOptions(newFilteredOptions);
      setHighlightedIndex(0);
    } else {
      setFilteredOptions(countryOptions);
      setHighlightedIndex(0);
    }
  }, [searchTerm]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (menuIsOpen) {
        switch (event.key) {
          case "ArrowDown":
            setHighlightedIndex((prevIndex) =>
              prevIndex < filteredOptions.length - 1 ? prevIndex + 1 : prevIndex
            );
            break;
          case "ArrowUp":
            setHighlightedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
            break;
          case "Enter":
            if (filteredOptions[highlightedIndex]) {
              handleCountryChange(filteredOptions[highlightedIndex]);
            }
            break;
          case "Escape":
            setMenuIsOpen(false);
            setSearchTerm("");
            break;
          default:
            if (event.key.length === 1) {
              setSearchTerm((prev) => prev + event.key);
            } else if (event.key === "Backspace") {
              setSearchTerm((prev) => prev.slice(0, -1));
            }
            break;
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    const resetSearch = setTimeout(() => setSearchTerm(""), 10000);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      clearTimeout(resetSearch);
    };
  }, [menuIsOpen, searchTerm, highlightedIndex, filteredOptions]);
  
  const handleDropdownToggle = () => {
    setMenuIsOpen(!menuIsOpen);
  };

  const handleCountryChange = (option) => {
    onChange(option ? option.value : "");
    setMenuIsOpen(false);
    setSearchTerm("");
  };

  const selectedOption = countryOptions.find((option) => option.value === selectedValue);

  const getPaddingLeft = (valueLength) => {
    switch (valueLength) {
      case 2:
        return "2.5rem";
      case 3:
        return "1.3rem";
      case 4:
        return ".4rem";
      case 5:
        return "0";
      default:
        return "0";
    }
  };

  return (
    <div className="country-code-select-container" ref={modalRef}>
      <Select
        classNamePrefix="country-code-select"
        value={selectedOption}
        onChange={handleCountryChange}
        options={filteredOptions}
        getOptionLabel={(e) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Flag code={e.flag} style={{ width: 20, height: 15 }} />
            <span style={{ marginLeft: 10 }}>
              {e.label} ({e.value})
            </span>
          </div>
        )}
        getOptionValue={(e) => e.value}
        menuIsOpen={menuIsOpen}
        onClick={handleDropdownToggle}
        styles={{
          option: (provided, state) => ({
            ...provided,
            backgroundColor:
              state.isFocused || state.data === filteredOptions[highlightedIndex]
                ? "#e0e0e0"
                : "white",
            color: "black",
          }),
        }}
      />
      <div
        className="dropdown-trigger"
        style={{ paddingLeft: selectedOption ? getPaddingLeft(selectedOption.value.length) : "2.5rem" }}
        onClick={handleDropdownToggle}>
        {selectedOption ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>{"+" + selectedOption.value}</span>
          </div>
        ) : (
          <span>{placeholder}</span>
        )}
        <span className="dropdown-arrow" style={{ marginLeft: "5px" }}>
          {menuIsOpen ? <img className="arrow-open arrow-img"  src={arrowDown} />: <img className="arrow-img" src={arrowDown} />}
        </span>
      </div>
    </div>
  );
};

export default CountryCodeSelect;
